import React, { Component, useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../../Components/MainLayout/Loader";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MySnackbar from "../../../Components/MyComponents/MySnackbar";
import Header from "../../../Components/MainLayout/Header";
import Authorize from "../../../../global/Authorize";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

function StudentSms(props) {
  const [studentData, setStudentData] = useState([]);
  const [message, setMessage] = useState(null);
  const [studentSmsNo, setStudentSmsNO] = useState(null);
  const [successSnackBar, setSuccessSnackBar] = useState(false);
  const [errorSnackBar, setErrorSnackBar] = useState(false);

  useEffect(() => {
    fetchStudents({
      school: props.user.user.school.id,
      session: props.user.session.id,
    });
  }, []);

  const fetchStudents = (params = {}) => {
    axios
      .get(`/api/session_student`, { params: { ...params } })
      .then((res) => setStudentData(res.data.results))
      .catch((err) => console.log("Failed to fetch students"));
  };

  const handleClick = (e) => {
    e.preventDefault();
    const response = {
      message,
      number: studentSmsNo,
      school: props.user.user.school.id,
    };
    axios
      .post("api/msendSMS", response)
      .then((res) => setSuccessSnackBar(true))
      .catch((err) => setErrorSnackBar(true));
  };

  const studentOptions = studentData.map((item) => (
    <option key={item.id} value={item.user.sms_number}>
      {item.user.first_name} | {item.roll_no} | {item.student_class.class_name}
    </option>
  ));

  return (
    <Authorize
      roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
      redirect
      to="/login"
    >
      <Header to="/home" title="Student SMS" />
      <div className="">
        <div className="container col-12 mt-3">
          <Link to="/smstemplate">
            <button className="th-btn-primary px-4 py-2 mb-4">
              SMS Template
            </button>
          </Link>
          <div className="th-18 th-fw-600 th-primary">
            PARTICULAR STUDENT SMS
          </div>
          <form action="">
            <div className="th-14 flex-column my-4">
              To Student
              <select
                className="ml-2"
                onChange={(e) => setStudentSmsNO(e.target.value)}
              >
                <option />
                {studentOptions}
              </select>
            </div>
            <div className="th-14 flex-column">
              Message
              <textarea
                className="form-control th-input-primary my-3"
                placeholder="Message"
                style={{ minHeight: 200 }}
                name="message"
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
            <div className="d-flex justify-content-end py-3">
              {/* {this.state.loading ? (
            <div className="my-1 pr-2">
              <Loader />
            </div>
          ) : null} */}
              <button
                onClick={handleClick}
                type="submit"
                className="th-btn-primary px-4 py-2"
              >
                Send SMS
              </button>
            </div>
          </form>
        </div>
        {successSnackBar ? <MySnackbar title="Sms Sent Successfully" /> : null}
        {errorSnackBar ? (
          <MySnackbar title="Failed to send Successfully" />
        ) : null}
      </div>
    </Authorize>
  );
}

export default withRouter(connect(mapStateToProps)(StudentSms));
